import * as ActionTypes from "./ActionTypes";
import axios from "axios";

export const setPromotions = info => {
	return {
		type: ActionTypes.LOAD_PROMOTIONS,
		promotions: info.data
	};
};

export const loadPromotions = () => {
	return dispatch => {
		axios
			.get("https://getupstudio.co/solanasapi/promociones")
			.then(response => {
				dispatch(setPromotions(response.data));
			})
			.catch(error => {});
	};
};

export const savePromotions = (promotion, token) => {
	return dispatch => {
		axios
			.update(
				"https://getupstudio.co/solanasapi/promociones/",
				promotion
			)
			.then(response => {
				dispatch(loadPromotions());
			})
			.catch(error => {});
	};
};

export const createPromotion = (promotion, token, imageUrl, backgroundUrl) => {

	console.log(promotion.titulo + ", " + promotion.descripcion + ", " + promotion.descuento + ", " +
	            promotion.orden + ", " + imageUrl + ", " + backgroundUrl);

	return dispatch => {
		axios
			.post(
				"https://getupstudio.co/solanasapi/promociones/",
				{
					titulo: promotion.titulo,
					descripcion: promotion.descripcion,
					orden: promotion.orden,
					image: imageUrl,
					descuento: promotion.descuento,
					backgroundImage: backgroundUrl
				}
			)
			.then(response => {
				dispatch(loadPromotions());
			})
			.catch(error => {});
	};
};

export const uploadImageThenBackground = (promotion, token) => {
	const formData = new FormData();
	formData.append("myImage", promotion.image);
	const config = {
		headers: {
			"content-type": "multipart/form-data"
		}
	};

	if(promotion.image == "") {
		uploadBackgroundThenCreatePromotion(promotion, token, "");
		return;
	}

	return dispatch => {
		axios
			.post(
				"https://getupstudio.co/solanasapi/promociones/imageupload",
				formData,
				config
			)
			.then(response => {
				dispatch(uploadBackgroundThenCreatePromotion(promotion, token, response.data));
			})
			.catch(error => {
				alert("Ocurrio al subir la imágen seleccionada. Error: " + error);
			});
	};
};

export const uploadBackgroundThenCreatePromotion = (promotion, token, imageUrl) => {
	const formData = new FormData();
	formData.append("myImage", promotion.backgroundImage);
	const config = {
		headers: {
			"content-type": "multipart/form-data"
		}
	};

	if(promotion.image == "") {
		createPromotion(promotion, token, imageUrl, "");
		return;
	}

	return dispatch => {
		axios
			.post(
				"https://getupstudio.co/solanasapi/promociones/imageupload",
				formData,
				config
			)
			.then(response => {
				dispatch(createPromotion(promotion, token, imageUrl, response.data));
			})
			.catch(error => {
				alert("Ocurrio al subir la imágen seleccionada. Error: " + error);
			});
	};
};

export const uploadImageThenBackgroundEdit = (promotion, token) => {
	const formData = new FormData();
	formData.append("myImage", promotion.image);
	const config = {
		headers: {
			"content-type": "multipart/form-data"
		}
	};
	return dispatch => {
		axios
			.post(
				"https://getupstudio.co/solanasapi/promociones/imageupload",
				formData,
				config
			)
			.then(response => {
				dispatch(uploadBackgroundThenEdit(promotion, token, response.data));
			})
			.catch(error => {
				alert("Ocurrio al subir la imágen seleccionada. Error: " + error);
			});
	};
};

export const uploadBackgroundThenEdit = (promotion, token, imageUrl) => {
	const formData = new FormData();
	formData.append("myImage", promotion.backgroundImage);
	const config = {
		headers: {
			"content-type": "multipart/form-data"
		}
	};
	return dispatch => {
		axios
			.post(
				"https://getupstudio.co/solanasapi/promociones/imageupload",
				formData,
				config
			)
			.then(response => {
				dispatch(editPromotion(promotion, token, imageUrl, response.data));
			})
			.catch(error => {
				alert("Ocurrio al subir la imágen seleccionada. Error: " + error);
			});
	};
};

export const uploadImageAndEditPromotion = (promotion, token) => {
	const formData = new FormData();
	formData.append("myImage", promotion.image);
	const config = {
		headers: {
			"content-type": "multipart/form-data"
		}
	};
	return dispatch => {
		axios
			.post(
				"https://getupstudio.co/solanasapi/promociones/imageupload",
				formData,
				config
			)
			.then(response => {
				dispatch(editPromotionOnlyImage(promotion, token, response.data));
			})
			.catch(error => {
				alert("Ocurrio al subir la imágen seleccionada. Error: " + error);
			});
	};
};

export const uploadBackgroundAndEditPromotion = (promotion, token) => {
	const formData = new FormData();
	formData.append("myImage", promotion.backgroundImage);
	const config = {
		headers: {
			"content-type": "multipart/form-data"
		}
	};
	return dispatch => {
		axios
			.post(
				"https://getupstudio.co/solanasapi/promociones/imageupload",
				formData,
				config
			)
			.then(response => {
				dispatch(editPromotionOnlyBackground(promotion, token, response.data));
			})
			.catch(error => {
				alert("Ocurrio al subir la imágen seleccionada. Error: " + error);
			});
	};
};

export const editPromotion = (promotion, token, imageUrl, backgroundUrl) => {

	console.log("Edit Promotion Both Images: " + imageUrl + ", " + backgroundUrl);

	return dispatch => {
		axios
			.post(
				"https://getupstudio.co/solanasapi/promociones/edit/",
				{
					titulo: promotion.titulo,
					descripcion: promotion.descripcion,
					image: imageUrl,
					descuento: promotion.descuento,
					backgroundImage: backgroundUrl,
					id: promotion.id
				}
			)
			.then(response => {
				dispatch(loadPromotions());
			})
			.catch(error => {});
	};
};

export const editPromotionOnlyImage = (promotion, token, imageUrl) => {

	console.log("Edit Promotion Only Image: " + imageUrl);

	return dispatch => {
		axios
			.post(
				"https://getupstudio.co/solanasapi/promociones/editOnlyImage/",
				{
					titulo: promotion.titulo,
					descripcion: promotion.descripcion,
					image: imageUrl,
					descuento: promotion.descuento,
					id: promotion.id
				}
			)
			.then(response => {
				dispatch(loadPromotions());
			})
			.catch(error => {});
	};
};

export const editPromotionOnlyBackground = (promotion, token, backgroundUrl) => {

	console.log("Edit Promotion Only BG: " + backgroundUrl);

	return dispatch => {
		axios
			.post(
				"https://getupstudio.co/solanasapi/promociones/editOnlyBG/",
				{
					titulo: promotion.titulo,
					descripcion: promotion.descripcion,
					descuento: promotion.descuento,
					backgroundImage: backgroundUrl,
					id: promotion.id
				}
			)
			.then(response => {
				dispatch(loadPromotions());
			})
			.catch(error => {});
	};
};

export const editPromotionNoImage = (promotion, token) => {

	console.log("Edit Promotion No Image: " + promotion.titulo + ", " + promotion.descripcion + ", " + promotion.id + ", " + promotion.descuento);

	return dispatch => {
		axios
			.post(
				"https://getupstudio.co/solanasapi/promociones/editnoimage/",
				{
					titulo: promotion.titulo,
					descripcion: promotion.descripcion,
					descuento: promotion.descuento,
					id: promotion.id
				}
			)
			.then(response => {
				dispatch(loadPromotions());
			})
			.catch(error => {});
	};
};

export const deletePromotion = (promotion, token) => {
	return dispatch => {

		axios
			.delete(
				"https://getupstudio.co/solanasapi/promociones/" +
					promotion.id,
				{ data: promotion }
			)
			.then(response => {
				dispatch(loadPromotions());
			})
			.catch(error => {});
	};
};
